module.exports = __webpack_public_path__ + "img/02.8891aee2.jpg";